import { Grid ,TextField, Button} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Preloader from "../../components/PreLoader";
import { lang } from "../../config/app.config";
import { fetchFormBySlug, submitForm } from "../../services/form.service";
import translate from '../../translation.json';
import { setFormdata } from "../../utils/common.utils";

const ContactForm:React.FC = ()=>{

  const [form,setForm] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  
  const loadForm = async()=>{
    setLoading(true);
    const form = await fetchFormBySlug('contct-form');
    setForm(form);
    setLoading(false);
  }

  useEffect(()=>{
    loadForm();
  },[]) //eslint-disable-line


  const [fields,setFields] = useState({
    name:'',
    email:'',
    message:'',
  });


  const onFieldChange = (e:React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>|React.ChangeEvent<{ name?: string; value: unknown }>,field:'name'|'email'|'message') =>{
    let value = e.target.value;
    setFields({
      ...fields,
      [field]:value
    });
    setResponseMessage(undefined)
  }


  const [submitting, setSubmitting] = useState<boolean>(false);
  const [responseMessage, setResponseMessage] = useState<{success:boolean,message:string}|undefined>(undefined);

  const resetForm = () =>{
    setFields({
      email:"",
      message:"",
      name:""
    })
  }

  const submit = async (e:React.FormEvent,id:number) =>{
    e.preventDefault();
    if(fields && fields.name && fields.email && fields.message){
      setSubmitting(true);
      let form:any ={...fields};
      form.form_id = id;
      let message = await submitForm(setFormdata(form));
      setResponseMessage(message);
      if(message.success){
        resetForm();
      }
      setSubmitting(false);
    }else{
      setResponseMessage({success:false,message:translate.translation[lang].please_fill_all_of_required_field})
    }
    
  }
  return(
    <>
    {
      loading || submitting?<Preloader/>:
      form?
      <>
      <form onSubmit={(e)=>submit(e,form.id)}>
        <div className="text-center">
          <div className="ecn-title mb-1">
            {form.title}
          </div>
        </div>
        {
          Object.keys(form.description).map((item:any,id)=>{
            if(form.description[item] === 'text'){
              return(
                <Grid item xs={12} key={id} >
                  <TextField
                    required
                    label={item + ` (${translate.translation[lang].required})`}
                    value={item === "नाम" || item === "name" ? fields.name:fields.email}
                    onChange={(e)=>onFieldChange(e,item === "नाम" || item === "name" ? 'name':'email')}
                    variant="outlined"
                    className="input-w-100 mb-2"
                  /> 
                </Grid>
              )
            }else{
              return(
                <Grid item xs={12}  key={id} >
                  <TextField
                    required
                    label={item+ ` (${translate.translation[lang].required})`}
                    variant="outlined"
                    multiline
                    onChange={(e)=>onFieldChange(e,'message')}
                    rows={7}
                    value={fields.message}
                    className="input-w-100 mb-2"
                  />
                </Grid>
              )
            }
          })
        }
       

        <Button className="btn-primary" type="submit" disabled={submitting}>
          {translate.translation[lang].send}
        </Button>
      </form>
      {responseMessage?
        <div className={responseMessage.success?"success-text m-1":"error-text m-1"}>
          {responseMessage.message || ""}
        </div>:''
      }
      </>
      :""
    }
  </>
  );
}

export default ContactForm;